import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AgencyComponent } from './agency/agency.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MainDashboardComponent } from './main-dashboard/main-dashboard.component';
import { SettingsComponent } from './settings/settings.component';
const routes: Routes = [ 
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  // { path: 'agency', component: AgencyComponent },

  { path: '' , component: DashboardComponent , children: [
    { path: 'main-dashboard', component: MainDashboardComponent   },
    { path: 'agency', component: AgencyComponent   },
    { path: 'settings', component: SettingsComponent   },


  ]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
